// src/components/access/ShowFeature.tsx
// UI visibility gating — checks exposure flags (not entitlement).
// Use RequireFeature for access control; use ShowFeature for "should the UI render this?"

import { useFeatureStore } from '@/stores/featureStore';
import type { ExposureKey } from '@/lib/features/featureFlags';

export function ShowFeature({ feature, children, fallback }: {
  feature: ExposureKey;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  const { exposureFlags } = useFeatureStore();

  if (!exposureFlags) return null; // not loaded yet
  if (!exposureFlags[feature]) return fallback ? <>{fallback}</> : null;

  return <>{children}</>;
}
